import EditDataApiPermissionDialog from "./edit/EditDataApiPermissionDialog";
import TableDeleteButton from "../../../../../../../shared/components/button/TableDeleteButton";
import { DataTable } from "../../../../../../../shared/components/data-table/DataTable";

const DataApiPermissionsTable = ({
  data,
  onDelete,
  onEdition,
  roles,
  datasets,
}) => {
  const columns = [
    {
      accessorKey: "role",
      header: "Rol",
      cell: ({ row }) => <div>{row.original.role.name}</div>,
    },
    { accessorKey: "key", header: "Dataset" },
    {
      accessorKey: "value",
      header: "Filtro a aplicar",
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <EditDataApiPermissionDialog
              onSubmitHandler={onEdition}
              permission={data}
              roles={roles}
              datasets={datasets}
            />
            <TableDeleteButton onClickHandler={() => onDelete(data.id)} />
          </div>
        );
      },
    },
  ];

  return <DataTable columns={columns} data={data} />;
};

export default DataApiPermissionsTable;
